<template>
  <div>
    <basic-container id="demandorder20210707">
      <el-form :inline="true" ref="form" :model="form">
        <el-row :gutter="20">
          <el-col span="6">
            <el-form-item label="项目名称" prop="projectId"  style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.projectId"
                placeholder="请选择项目"
                @change="changeProject"
                size="small"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="完成标准" required prop="criterion" :rules="[{ required: true, message: '请选择完成标准', trigger: 'blur' },]" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.criterion"
                placeholder="请选择完成标准"
                size="small"
              >
              <el-option
                  v-for="(item, index) in norm"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8" >
            <el-form-item label="完成日期" required prop="finishTime" :rules="[{ required: true, message: '请选择日期', trigger: 'blur' },]" >
                <el-date-picker
                  :clearable="false"
                  style="min-width:200px"
                  v-model="form.finishTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="4" style="text-align:right">
            <el-form-item>
              <el-button type="primary" size="small" @click="onSubmit" icon="el-icon-search" >搜 索</el-button>
              <el-button type="primary" size="small" @click="searchReset" icon="el-icon-delete"> 清 空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params"/>
    </basic-container>
  </div>
</template>

<script>
import urlSettings from '@/config/url-settings';
import WebReport from '@/components/web-report';
import {getProjectList,getDictData} from "@/api/crmedical/report/questionnaire.js";
import dayjs from 'dayjs';
export default {
  components: {
    WebReport,
  },
  data() {
    var date=new Date();
        date.setDate(1);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
    return {
      url: '',
      title:'维修工单完成情况统计表(科室)',
      projectName:'',
      form: {
        projectId: [],
        criterion:'',
        finishTime:[new Date(date), new Date()],
      },
      projectList: [],
      oldOptions: [],
      params: {
        reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/demandOrderReport.cpt',
        //  reportlet: 'demandOrderReport.cpt',
      },
      dic: [],
      norm:[],
    };
  },
  methods: {
    changeProject(e){
      this.projectIdList.forEach(ele => {
        if(ele.id == e){
          this.projectName = ele.name;
        }
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.form.finishTime)
          this.params.projectId = this.form.projectId;
          this.params.title = this.projectName +' ' + this.title;
          this.params.startTime = dayjs(this.form.finishTime[0]).format('YYYY-MM-DD 00:00:00');
          this.params.endTime = dayjs(this.form.finishTime[1]).format('YYYY-MM-DD 23:59:59');
          this.params.time = `完成日期:${dayjs(this.form.finishTime[0]).format('YYYY年MM月DD日')}-${dayjs(this.form.finishTime[1]).format('YYYY年MM月DD日')}`
          this.params.criterion = this.form.criterion;
          var reportUrl = urlSettings.BASE_REPORT_URL;
          this.url = reportUrl.split('?')[0];
          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    searchReset(){
      if (this.projectIdList.length > 0) {
        this.form.projectId = this.projectIdList[0].id;
        this.projectName = this.projectIdList[0].name;
      }
      let date=new Date();
      date.setDate(1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      this.form.finishTime = [new Date(date), new Date()];
      this.$forceUpdate();
      this.onSubmit();
    },

    initPropertyList() {
      // this.form.finishTime =
      getProjectList({}).then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.form.projectId = this.projectIdList[0].id;
          this.params.title = this.projectIdList[0].name +' ' + this.title;
        }

        var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];
        // this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=demandOrderReport.cpt';

        this.params.projectId = `${this.projectIdList[0].id}`;
        this.params.startTime = dayjs(this.form.finishTime[0]).format('YYYY-MM-DD 00:00:00');
        this.params.endTime = dayjs(this.form.finishTime[1]).format('YYYY-MM-DD 23:59:59');
        this.params.time = `完成日期:${dayjs(this.form.finishTime[0]).format('YYYY年MM月DD日')}-${dayjs(this.form.finishTime[1]).format('YYYY年MM月DD日')}`

      setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {
    this.initPropertyList();
    getDictData({code:'order_finish_standard'}).then(res=>{
      this.norm = res.data;
      this.form.criterion = this.norm[0]?this.norm[0].dictKey:'';

    })
  },
};
</script>

<style>

#demandorder20210707 .el-date-editor .el-range__icon{
  line-height: 24px;
}
#demandorder20210707 .el-form-item__content{
  flex-grow: 1;
  flex-shrink: 1;
}
#demandorder20210707 .el-form-item__label{
  flex-grow: 0;
  flex-shrink: 0;
}
#demandorder20210707 .is-required{
  display: flex;
}
</style>
